<template>
    <div class="card">
        <div class="card-image">
            <figure class="image is-4by3">
                <img :src="imageUrl" :alt="name">
            </figure>
        </div>
        <div class="card-content">
            <div class="media">
                <div class="media-left" v-if="iconUrl">
                    <figure class="image is-48x48">
                        <img :src="iconUrl" :alt="name + ' (icon)'" v-if="iconUrl">
                    </figure>
                </div>
                <div class="media-content">
                    <p class="title is-4">{{name}}</p>
                    <p class="subtitle is-6">{{status}}</p>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <router-link class="card-footer-item" :to="detailRoute">Details</router-link>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['name', 'imageUrl', 'iconUrl', 'status', 'detailRoute'],
        name: "ProgramCard",
    }
</script>
